import { Injectable } from '@angular/core';
import { ApiService, IApiOption } from '@red/api';
import { PaginationAdapter } from '@red/data-access';
import { EcddActionDto, EcddFileDto, EcddRejectedDto, EcddUpdateRemarkDto, EcddV2ApprovedDto, EcddV2ApprovedFormCDto, EcddV2RejectedDto } from '@shared/data-access/dto';
import { ECDDMasteModel, EcddModel } from '@shared/data-access/models';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EcddV2ApiService {
  static ROOT_POINT = 'transaction/ecdds-v2';
  static REJECT_POINT = 'transaction/ecdds-v2/reject';
  static APPROVE_POINT = 'transaction/ecdds-v2/action';
  static VERIFICATION_POINT = 'transaction/ecdds-v2/verifications';
  static DOWNLOAD_PDF_POINT = 'transaction/ecdds-v2/:id/download-pdf';
  static FOR_RESALE_POINT = 'transaction/ecdds-v2/for-resale';
  static APPROVE_FORM_C_POINT = 'transaction/ecdds-v2/:id/review-form-c';
  static ROOT_POINT_REWORK = 'transaction/ecdds-v2/rework';

  constructor(private apiService: ApiService) { }

  search(query = {}, option?: IApiOption): Observable<PaginationAdapter<ECDDMasteModel>> {
    return this.apiService.get(EcddV2ApiService.ROOT_POINT, query, { ...option, removeEmpty: { enable: true } }).pipe(map(data => new PaginationAdapter(ECDDMasteModel, data)));
  }

  searchVerification(query = {}, option?: IApiOption): Observable<PaginationAdapter<ECDDMasteModel>> {
    return this.apiService.get(EcddV2ApiService.VERIFICATION_POINT, query, { ...option, removeEmpty: { enable: true } }).pipe(map(data => new PaginationAdapter(ECDDMasteModel, data)));
  }

  get(id: number): Observable<EcddModel> {
    return this.apiService.get(EcddV2ApiService.ROOT_POINT + '/' + id).pipe(map(res => EcddModel.fromJson(res) as EcddModel));
  }

  approve(payload: EcddV2ApprovedDto) {
    return this.apiService.post(EcddV2ApiService.APPROVE_POINT, payload);
  }

  reject(payload: EcddV2RejectedDto) {
    return this.apiService.post(EcddV2ApiService.REJECT_POINT, payload);
  }

  // viewPdf(id: number): Observable<any> {
  //   return this.apiService.get(
  //     EcddV2ApiService.DOWNLOAD_PDF_POINT,
  //     { id },
  //     {
  //       pretreatmentResponse: false,
  //       requestOptions: { responseType: 'arraybuffer' },
  //     }
  //   );
  // }

  viewPdf(id: number, data: EcddFileDto): Observable<any> {
    const fileId = Number(data.fileId);
    return this.apiService.get(EcddV2ApiService.ROOT_POINT + '/' + id + '/download-pdf', { fileId });
  }

  searchForResale(query = {}, option?: IApiOption) {
    return this.apiService.get(EcddV2ApiService.FOR_RESALE_POINT, query, option).pipe(map(data => new PaginationAdapter(EcddModel, data)));
  }

  updateRemarks(id: number, data: EcddUpdateRemarkDto): Observable<any> {
    return this.apiService.patch(EcddV2ApiService.ROOT_POINT + '/' + id + '/remarks', data);
  }

  approveFormC(payload: EcddV2ApprovedFormCDto) {
    return this.apiService.post(EcddV2ApiService.ROOT_POINT + '/' + payload.ecddId + '/review-form-c', payload);
  }

  rejectFormC(payload: EcddV2ApprovedFormCDto) {
    return this.apiService.post(EcddV2ApiService.ROOT_POINT + '/' + payload.ecddId + '/review-form-c', payload);
  }

  approveFormU6(payload: EcddV2ApprovedFormCDto) {
    return this.apiService.post(EcddV2ApiService.ROOT_POINT + '/' + payload.ecddId + '/review-form-u6', payload);
  }

  rejectFormU6(payload: EcddV2ApprovedFormCDto) {
    return this.apiService.post(EcddV2ApiService.ROOT_POINT + '/' + payload.ecddId + '/review-form-u6', payload);
  }

  rework(id: number) {
    return this.apiService.post(EcddV2ApiService.ROOT_POINT_REWORK + '/' + id);
  }

  viewQuickAmlReport(id: number, screeningId: number): Observable<any> {
    return this.apiService.get(EcddV2ApiService.ROOT_POINT + '/' + id + '/quick-aml-report', { screeningId });
  }
}
